import { Component, inject } from '@angular/core';
import { SettlementsService } from 'src/app/services/settlements.service';
import { faEdit, faPlus, faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { BreadcrumbService } from 'xng-breadcrumb';
import { AuthService } from 'src/app/shared/services/auth.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-services',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Combustible</h1>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block">        
        <ul #subnav app-nav-tanques [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-auto">
        <div class="d-flex mb-3">
          <div class="flex-fill ms-2">
            <h2 class="mt-2 mt-md-0 mb-0">Servicios</h2>
            <p class="text-muted" style="font-size: 14px;">Configura los servicios asociados al condominio.</p>
          </div>
        </div>
        <div class="d-flex">
          <div class="flex-fill ms-3 me-3">
            <div class="input-group mb-3">
              <form [formGroup]="searchBox" (ngSubmit)="searchUtilities($event)">
                <input class="form-control border-secondary border-end-0 rounded-start-3 bg-transparent" placeholder="Buscar..." formControlName="search">
              </form>
            </div>
          </div>
          <div>
            <button class="btn btn-zazz-dark" *ngIf="authService.hasPermission('can_create_services')" routerLink="create">
            <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon>
              Agregar servicio</button>
          </div>
        </div>
        <div class="list-group rounded-4 rounded-md-5">
          <div class="list-group-item table-responsive py-4">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-left-3 py-2">Servicio</th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2">Descripción</th>
                  <th scope="col" class="text-end bg-zazz align-items-center align-middle text-light rounded-top-right-3 py-2"></th>
                </tr>
              </thead>
              <tbody *ngIf="utilities.length > 0 && !loading">
                <tr *ngFor="let utility of utilities | paginate: { itemsPerPage: payload.per_page, currentPage: p, totalItems: meta.total_entries }">
                  <td class="align-middle text-start">{{utility.name}}</td>
                  <td class="align-middle text-start">{{utility.description}}</td>
                  <td class="align-middle text-end">
                    <button class="btn btn-link text-secondary" routerLink="{{utility.id}}">
                      <fa-icon [icon]="icons.faEdit"></fa-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="text-center py-5" *ngIf="utilities.length==0&&loading">
              <fa-icon [icon]="icons.faCircleNotch" size="2x" animation="spin" class="text-secondary"></fa-icon>
              <p class="text-muted">Cargando...</p>
            </div>
            <div class="text-center py-5" *ngIf="utilities.length==0&&!loading">
              <img src="/assets/images/empty-state.png" width="240px">
              <h5 class="text-muted">No se encontraron registros</h5>
            </div>
          </div>
          <div class="list-group-item text-center pt-3">
            <pagination-controls
              (pageChange)="p = $event"
              (pageChange)="pageChanged($event)"
              previousLabel="Prev."
              nextLabel="Sig."
              screenReaderPaginationLabel="Pagination"
              screenReaderPageLabel="page"                  
            ></pagination-controls>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class ServicesComponent {
  loading: boolean = false;
  utilities: any[] = [];
  meta: any = {};
  searchBox: FormGroup = new FormGroup({});
  profile: any = {};
  permissions: any = {};
  currentView: string = 'services';

  payload: any = {
    page: 1,
    per_page: 10,
  };

  p: number = 1;
  storageService = inject(StorageService);
  constructor(
    private store: SettlementsService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public authService: AuthService,
    public icons: IconsService
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : null;
    this.payload.profile_id = this.profile.id;
  }

  ngOnInit(): void {
    this.loadUtilities(this.payload);
    this.initForm();
  }

  loadUtilities(payload: any) {
    this.loading = true;
    this.store.getUtilities(payload).subscribe({
      next: (utilities: any) => {
        this.utilities = utilities.data;
        this.meta = utilities.meta;
        this.loading = false;
      },
      error: (err: any) => {
        console.log(err);
        this.loading = false;
        this.utilities = [];
        this.toastr.error('Ocurrió un error al obtener las amenidades.', 'Error');
      }
    });
  }

  initForm() {
    this.searchBox = this.fb.group({
      search: ['']
    })
  }

  pageChanged(event: any) {
    this.payload.page = event;
    this.loadUtilities(this.payload);
  }

  searchUtilities(event: any) {
    this.payload.page = 1;
    this.payload.name = this.searchBox.value.search;
    this.loadUtilities(this.payload);
  }
}
